<div class="globalSearch">
  <div class="search-field-header">
    <div (click)="toggle($event)" class="pointer"
         style="border: 1px solid #D0D5DD;border-radius: 4px;padding: 10px 14px;">
      <span *ngIf="searchLabels.length > 3" style="font-size: 25px;margin:0 5px;">...</span>
      <img src="../../../images/tpiq-icons/SVG/filter.svg"> Filters
    </div>
  </div>
</div>

<div *ngIf="reveal['search']">
  <div [ngClass]="{'tpiq-reveal': reveal['search']}" class="reveal-overlay">
    <div [ngClass]="{'tpiq-reveal': reveal['search']}" class="reveal tax-strategy-reveal"
         style="width: 50% !important;overflow: initial;">
      <div style="height: 50px; padding: 15px; color: #333333;">
        <span class="float-left">Search</span>
        <span (click)="hideReveal('search', true)" class="float-right pointer">X</span>
      </div>
      <div style="padding: 0 15px;">
        <hr style="margin: 0;"/>
      </div>
      <div class="body reveal-publish new-input-fields" style="padding: 15px;">
        <div class="row row-padding-reveal">
          <div class="small-10 medium-10">
            <div class="row dropdown-select">
              <div class="small-4 medium-3 columns">
                <label class="label-name label-top">Labels</label>
              </div>
              <div class="small-4 medium-7 columns">
                <div class="filter-option-wrapper-max" id="company-dropdown" style="margin-right: 10px;" *ngIf="labelsDropdownSettings && labelsList">
                  <ng-multiselect-dropdown
                    [settings]="labelsDropdownSettings"
                    [data]="labelsList"
                    [placeholder]="'Select Labels'"
                    [(ngModel)]="searchModel.selectedLabels"
                    (onSelect)="onClientFilterSelect($event, true)"
                    (onDeSelect)="onClientFilterSelect($event, false)"
                    (onSelectAll)="onAllClientsFilterSelect($event, true)"
                    (onDeSelectAll)="onAllClientsFilterSelect($event, false)"
                    name="company">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
          </div>
          <div class="small-2 medium-2"></div>
          <div class="small-10 medium-10 mt-3">
            <div class="row dropdown-select">
              <div class="small-4 medium-3 columns">
                <label class="label-name label-top">Status</label>
              </div>
              <div class="small-4 medium-7 columns">
                <label>
                  <app-tpiq-select-dropdown (onValueSelect)="setStatus($event)" [includeNone]="false"
                                            [setData]="statusTypes"
                                            [setDefaultValue]="searchModel.status || ''" [setPlaceHolder]="'Status'"
                                            [setSearchKey]="'name'"
                                            [setValueKey]="'name'"></app-tpiq-select-dropdown>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="padding-top: 1rem;">
          <div class="small-4 medium-12 text-right">
            <button (click)="advanceLabelsSearch()" class="button small post-button" data-close type="submit">Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
